import { ScaleElement } from '@scale/base-element';
import { Events } from '@scale/events';
import { formatMoney } from '@scale/currency';

class ProductPrice extends ScaleElement {
  #currentVariant;

  setup() {
    this.onDocument(Events.VARIANT_SELECTED, (e) => {
      this.#currentVariant = e.variant;
      this.#update(e.variant);
    });

    this.onDocument(Events.SUBSCRIPTION_UPDATED, (e) => {
      this.#onSubscriptionChanged(e.detail?.sellingPlan || e.sellingPlan);
    });
  }

  #update(variant) {
    if (!variant) return;

    const price = this.ref('price');
    const compare = this.ref('compare-price');
    const badge = this.ref('sale-badge');
    const unit = this.ref('unit-price');

    if (price) price.textContent = formatMoney(variant.price);

    const onSale = variant.compare_at_price > variant.price;

    if (compare) {
      compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      compare.hidden = !onSale;
    }

    if (price) price.classList.toggle('product-price__current--sale', onSale);

    if (badge) {
      if (onSale) {
        const savings = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        badge.textContent = `${savings}% OFF`;
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
    }

    if (unit && variant.unit_price) {
      unit.textContent = `${formatMoney(variant.unit_price)}/${variant.unit_price_measurement?.reference_unit || ''}`;
      unit.hidden = false;
    } else if (unit) {
      unit.hidden = true;
    }
  }

  #onSubscriptionChanged(sellingPlanId) {
    if (!this.#currentVariant) return;

    const price = this.ref('price');
    const compare = this.ref('compare-price');
    if (!price) return;

    if (sellingPlanId) {
      // Find the selling plan allocation for this variant
      const allocation = this.#currentVariant.selling_plan_allocations?.find(
        a => a.selling_plan_id === Number(sellingPlanId)
      );

      if (allocation) {
        price.textContent = formatMoney(allocation.per_delivery_price);
        if (compare) {
          compare.textContent = formatMoney(this.#currentVariant.price);
          compare.hidden = false;
        }
        price.classList.add('product-price__current--sale');
        return;
      }
    }

    // No subscription — revert to regular price
    this.#update(this.#currentVariant);
  }
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
